<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card">
              <div class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                <table class="table table-head-fixed table-hover-animation text-nowrap">
                  <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Charges</th>
                    <th>Charges Type</th>
                    <th>GW Charges</th>
                    <th>GW Type</th>
                    <th v-if="data.apply_in_limits == 1">Amount</th>
                    <th v-if="data.apply_in_limits == 1">Condition</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :key="index" v-for="(row, index) in list">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.charges }}</td>
                    <td>{{ row.type }}</td>
                    <td>{{ row.gwcharges }}</td>
                    <td>{{ row.gwType }}</td>
                    <td v-if="data.apply_in_limits == 1">{{ parseFloat(parseFloat(row.amount)/100).toFixed(feesDecimalPlaces) }}</td>
                    <td v-if="data.apply_in_limits == 1">{{ row.condition }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import Charges from "@/pages/dashboard/charges/charges.vue";

export default {
  components: {Charges},
  props: ["show", "data", "index"],
  data() {
    return {
      list: []
      // showModal: false,
    };
  },
  methods:{
  },
  watch: {
    show() {
      if (this.show) {
        this.list = this.data.charges
      }
    },
  }
};
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

